import { configure } from 'mobx';
import * as React from 'react';
// eslint-disable-next-line import/no-internal-modules
import { createRoot } from 'react-dom/client';
import App from './src/App';
import config from './src/Config';
import PageErrorBoundary from './src/error/PageErrorBoundary';

configure({
  enforceActions: 'never',
  isolateGlobalState: false
});

if (window.INITIAL_CONFIG) {
  config.initialize(window.INITIAL_CONFIG);
} else {
  window.addEventListener('message', (ev) => {
    if (ev.data === 'config-loaded' && window.INITIAL_CONFIG) {
      config.initialize(window.INITIAL_CONFIG);
    }
  });
}

const root = createRoot(document.getElementById('sso-container')!);

root.render(
  <PageErrorBoundary>
    <App />
  </PageErrorBoundary>
);
